import { gql, useQuery } from "@apollo/client";
import { useState } from "react";

const RUNESTONE_BANNER_QUERY = gql`
    query RunestoneBanner {
        myAccount {
            isStreamTeam
            isStreamTeamAcademy
            hasRunestone
        }
    }
`;

export function RunestoneBanner() {
    const [dismissed, setDismissed] = useState(false);
    const { data, loading } = useQuery(RUNESTONE_BANNER_QUERY);

    const isStreamTeam = data?.myAccount?.isStreamTeam ?? false;
    const isAcademyMember = data?.myAccount?.isStreamTeamAcademy ?? false;
    const hasRunestone = data?.myAccount?.hasRunestone ?? false;

    if (
        loading ||
        !isStreamTeam ||
        isAcademyMember ||
        hasRunestone ||
        dismissed
    ) {
        return null;
    }

    return (
        <div
            className="fixed right-0 bottom-0 left-0 z-40 bg-zinc-800 p-4 shadow-lg"
            role="alert"
            aria-live="polite"
        >
            <div className="container mx-auto flex items-center justify-between">
                <div className="flex items-center gap-3">
                    <span className="shrink-0 text-2xl">᚛</span>
                    <div>
                        <p className="font-semibold text-white">
                            You haven't carved your Runestone yet!
                        </p>
                        <p className="text-sm text-zinc-300">
                            Leave your mark on the Rookery — carve your
                            Runestone in the Forge.
                        </p>
                    </div>
                </div>
                <div className="flex gap-2">
                    <button
                        onClick={() => {
                            window.location.href = "/runestone-carving";
                        }}
                        className="rounded bg-yellow-400 px-4 py-2 font-semibold text-zinc-900 transition hover:bg-yellow-300"
                    >
                        Carve Runestone
                    </button>
                    <button
                        onClick={() => setDismissed(true)}
                        className="rounded border border-white px-4 py-2 font-semibold text-white transition hover:bg-zinc-600"
                    >
                        Dismiss
                    </button>
                </div>
            </div>
        </div>
    );
}
